import { ToastHub } from "@components/ToastHub"
import { createContext, PropsWithChildren, useCallback, useRef } from "react"

type ToastFunction = (message: string, duration?: number) => void

export const ToastContext = createContext<ToastFunction | undefined>(undefined)

export function ToastProvider({ children }: PropsWithChildren<any>) {
  const addToastRef = useRef(null)

  const addToast = useCallback((message: string, duration = 3000) => {
    // Ошибка с never
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    if (addToastRef.current) addToastRef.current({ duration, message })
  }, [])

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <ToastHub>
        {(add) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          addToastRef.current = add
        }}
      </ToastHub>
    </ToastContext.Provider>
  )
}
